export default function Footer() {
  return (
    <footer className="w-full h-16 border-t border-primary shadow-md bg-black/25 flex items-center justify-center px-4">
      <section className="flex gap-2 text-sm items-center text-gray-500">
        <img src="/logo_white.png" alt="SubtopFR" className="h-6" />
        <span>
          SubtopFR &ndash; Made by{' '}
          <a
            href="http://x.com/0xNescabir"
            target="_blank"
            rel="noopener noreferrer"
            className="text-secondary hover:text-secondary/80 font-bold transition-colors"
          >
            NES
          </a>{' '}
          with ❤️ &ndash; In collaboration with{' '}
          <a
            href="https://la-scene.gg"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-white/80 font-play font-bold transition-colors group"
          >
            La scène<span className='text-[#FF6B35] text-[10px] font-bold pb-[1px] group-hover:text-[#FF6B35]/80 transition-colors'>.gg</span>
          </a>
        </span>
      </section>
    </footer>
  );
}
